var React = require('react');

function DecoBlob18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M782.486 1356.36C612.571 1119.66 317.825 1114.45 199.768 1029.06C22.1821 900.504 2.91659 574.916 500.607 431.845C998.298 288.775 1152.51 290.306 1373.72 523.875C1550.73 710.775 1528.96 1004.58 1458.74 1166.38C1348.89 1419.55 952.334 1592.97 782.486 1356.36Z","fill":"#2D63D7"}));
}

DecoBlob18.defaultProps = {"width":"1440","height":"1778","viewBox":"0 0 1440 1778","fill":"none"};

module.exports = DecoBlob18;

DecoBlob18.default = DecoBlob18;
